import React, { useEffect, useRef, useState } from 'react'

function ImageSource({ src, alt, className }) {
  const imageRef = useRef(null)
  const [state, setState] = useState('loading')

  useEffect(() => {
    let active = true
    const image = imageRef.current
    const failed = () => { if (active) setState('failed') }
    const loaded = async () => {
      try {
        if (!image.naturalWidth) return failed()
        // A fetched image is not necessarily decoded yet. Printing waits for
        // this marker as well as the native image's completed state.
        if (typeof image.decode === 'function') await image.decode()
        if (active) setState('loaded')
      } catch { failed() }
    }
    image.addEventListener('load', loaded)
    image.addEventListener('error', failed)
    if (image.complete) loaded()
    return () => {
      active = false
      image.removeEventListener('load', loaded)
      image.removeEventListener('error', failed)
    }
  }, [])

  return (
    <div data-contract-image-state={state}>
      <img ref={imageRef} src={src} alt={alt} className={className} hidden={state === 'failed'} />
      {state === 'loading' && <p role="status" className="mt-2 text-sm text-foreground">Loading {alt.toLowerCase()}…</p>}
      {state === 'failed' && (
        <p role="alert" className="rounded-lg border border-destructive/30 bg-destructive/10 p-3 text-sm text-destructive">
          Could not load {alt.toLowerCase()}. Reload the contract and check the image before printing.
        </p>
      )}
    </div>
  )
}

// A source change starts a fresh load/error lifecycle; no stale decoded image
// or error state can carry across two different purchases.
export default function CaptureImage(props) {
  return <ImageSource key={props.src} {...props} />
}
